/**
 *
 * CollapseButtonLine
 *
 */

import React, { memo, FunctionComponent } from 'react';
import { StyledCollapseButtonLine } from './styledComponents';

interface IProps {
  position: 'left' | 'right';
  expanded: boolean;
  onClick: () => void;
}

const CollapseButtonLine: FunctionComponent<IProps> = ({
  position,
  expanded,
  onClick,
}) => {
  return (
    <StyledCollapseButtonLine position={position} expanded={expanded}>
      <button onClick={onClick} />
    </StyledCollapseButtonLine>
  );
};

export default memo(CollapseButtonLine);
